import React, { useState } from "react";
import { Row } from "reactstrap";
import { useLocation } from "react-router-dom";
import { QuizDescription } from "./QuizDescription";
import { QuizContent } from "./QuesstionContent";
import OpenButton from "../../components/buttons/OpenButton";
import SimpleModal from "../../components/modals/SimpleModal";
import { size } from "lodash";
import { Speaking } from "./speaking";
import { exerciseType } from "../../components/constants/constants";
import { ShowQuestions } from "./ShowQuestions";
import { QuizyUrl } from "../../libs/env";
import { TempHeader } from "./TempHeader";

export const Quiz = ({
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  setIsonRecorder,
  timer,
  isOpenAdditionalResourceModal,
  setOpenAdditionalResourceModal,
  additionalResourceToggle,
  setSpeakingUrl,
  questions,
  currentPage,
  onblur,
  answers,
  setCurrentPage,
  visualizerToggle,
  onUpdate,
  setanswerSheet,
  comp_answer,
  setoptionsSheet,
  print_options,
  quesRef,
  headerRef,
}) => {
  const { pathname } = useLocation();
  const [Contentedit, setContentedit] = useState(false);
  let params = new URL(document.location).searchParams;
  let quizy_template = params.get("quizy_template");
  let edit_template = "false"
  let question_scroll = "pt-2";
  let instrItalic ="";
  // if(edit_template === "true" || pathname.includes(TempUrl)){
  //   question_scroll = "template_scroll preview_fsize";
  //   instrItalic = "";
  //   edit_template = "true";
  // }
  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container && window.location.origin.includes(QuizyUrl) && !quizy_template)
    {
      container.classList.add('scrollable_scroll');
      clearTimeout(timer);
      timer = setTimeout(() => {
        container.classList.remove('scrollable_scroll');
      }, 1000);
    }
  };
  if (window.location.origin.includes(QuizyUrl) && !quizy_template) {
    question_scroll = "question_scroll";
    instrItalic = "";
  }
  if (!data.status) {
    localStorage.clear();
  }
  return (
    <div id="scroll" onScroll={handleScroll} className={`${question_scroll} bg-white`}>
      <div ref={headerRef} className="Question__description">
        {window.location.origin.includes(QuizyUrl) || quizy_template === "true" ? (
          <TempHeader
          isReview={isReview}
          data={data}
          isStopTimer={isStopTimer}
          setIsStopTimer={setIsStopTimer}
          timer={timer}
          edit_template={edit_template}
          />
        ):(
          <QuizDescription
            isReview={isReview}
            data={data}
            isStopTimer={isStopTimer}
            setIsStopTimer={setIsStopTimer}
            timer={timer}
            Contentedit={Contentedit}
            edit_template={edit_template}
          />
        )}
        <Row className="border bg-white border-top-0 border-bottom-0 px-4 py-2">
          <QuizContent
            data={data}
            studentid={data.school_student_id}
            studentAssessmentId={data.student_assessment_id}
            isReview={isReview}
            visualizerToggle={visualizerToggle}
            onUpdate={onUpdate}
            instrItalic={instrItalic}
            setContentedit={setContentedit}
            Contentedit={Contentedit}
            pathname={pathname}
          />
        </Row>
      </div>
      <Row
        className={
          size(data.additional_resource) <= 0
            ? ""
            : "border bg-white border-top-0 border-bottom-0 px-4 py-2"
        }
      >
        {size(data.additional_resource) <= 0 ? (
          ""
        ) : (
          <div>
            <p className="quiz-bottom-border mb-3"></p>
            <span class="mt-3 mb-3">
              <strong> Additional question resource </strong>
              <OpenButton
                onClick={() =>
                  setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal)
                }
              />
            </span>
            <p className="quiz-bottom-border mt-3"></p>
          </div>
        )}

        <SimpleModal
          isOpen={isOpenAdditionalResourceModal}
          toggle={additionalResourceToggle}
          bodyContent={
            <div
              dangerouslySetInnerHTML={{
                __html: data.additional_resource,
              }}
            />
          }
          footerContent={
            <button
              type="submit"
              class="btn btn-sm mx-3 modal-button"
              onClick={additionalResourceToggle}
            >
              Close
            </button>
          }
        />
      </Row>
      <Row
        className="border bg-white border-top-0 border-bottom-0 px-4"
      >
        {data.task_type === exerciseType.SPEAKING_TASK ? (
          null
        ) :
        data.task_type === exerciseType.PRONUNCIATION_TASK ? (
          <Speaking
            Studentname={data.school_student_name}
            speakingUrl={setSpeakingUrl}
            setIsonRecorder={setIsonRecorder}
            speaking_data={data.speaking_plain_text_for_ml}
            isReview={isReview}
            speakingResponseURL={data.listening_file_url}
          />
        ) : (
          <div>
            <ShowQuestions
              questions={questions}
              currentPage={currentPage}
              onAnswer={onblur}
              isReview={isReview}
              answer={answers}
              status={data.status}
              data={data}
              ai_grading_exercise={data?.ai_grading_task}
              onUpdate={onUpdate}
              setanswerSheet={setanswerSheet}
              comp_answer={comp_answer}
              setoptionsSheet={setoptionsSheet}
              print_options={print_options}
              quesRef={quesRef}
            />
          </div>
        )}
      </Row>
      {/* {isReview || data.total_pages === 1 ? null : (
        <>
          <CustomPagination
            data={data}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </>
      )} */}
    </div>
  );
};
